import React, { useState } from "react";
import {
  Box,
  Container,
  Grid,
  Text,
  VStack,
  HStack,
  Link,
  Input,
  Button,
  Divider,
  useColorMode,
  useColorModeValue,
  Icon,
  useToast,
  Flex,
  Heading,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import {
  FiDroplet,
  FiCheck,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiHeart,
  FiGift,
  FiStar,
} from "react-icons/fi";

const Footer: React.FC = () => {
  const { colorMode } = useColorMode();
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "gray.700");
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const toast = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setEmail("");
      toast({
        title: "Subscribed successfully!",
        description: "Thank you for subscribing to our newsletter.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    }, 1000);
  };

  return (
    <Box as="footer" bg={bgColor} color={textColor} py={12}>
      <Container maxW="1400px">
        <Grid templateColumns={["1fr", "1fr 1fr", "1fr 1fr 1fr 1fr"]} gap={8}>
          {/* Brand Section */}
          <VStack align="start" spacing={4}>
            <HStack>
              <Icon as={FiDroplet} w={8} h={8} color="purple.600" />
              <Text fontSize="2xl" fontWeight="bold" color="gray.700">
                Luxe Perfumes
              </Text>
            </HStack>
            <Text>
              Discover our collection of exquisite fragrances, crafted with the finest ingredients from around the world. Each scent tells a unique story of luxury and sophistication.
            </Text>
          </VStack>

          {/* Quick Links */}
          <VStack align="start" spacing={4}>
            <Heading size="md">Quick Links</Heading>
            <Link as={RouterLink} to="/about">
              About Us
            </Link>
            <Link as={RouterLink} to="/contact">
              Contact
            </Link>
            <Link as={RouterLink} to="/sale">
              Special Offers
            </Link>
          </VStack>

          {/* Collections */}
          <VStack align="start" spacing={4}>
            <Heading size="md">Collections</Heading>
            <VStack align="start" spacing={2}>
              <Link as={RouterLink} to="/category/floral">
                Floral
              </Link>
              <Link as={RouterLink} to="/category/oriental">
                Oriental
              </Link>
              <Link as={RouterLink} to="/category/woody">
                Woody
              </Link>
              <Link as={RouterLink} to="/category/fresh">
                Fresh
              </Link>
              <Link as={RouterLink} to="/category/gourmand">
                Gourmand
              </Link>
              <Link as={RouterLink} to="/category/aromatic">
                Aromatic
              </Link>
            </VStack>
          </VStack>

          {/* Newsletter */}
          <VStack align="start" spacing={4}>
            <Heading size="md" color="purple.600">Stay Updated</Heading>
            <Text color="gray.600" fontSize="sm">
              Subscribe to our newsletter for exclusive offers, new arrivals, and fragrance tips.
            </Text>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <VStack spacing={3} align="stretch">
                <InputGroup>
                  <Input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    bg="white"
                    borderWidth="2px"
                    borderColor="purple.200"
                    _hover={{ borderColor: "purple.400" }}
                    _focus={{ borderColor: "purple.500" }}
                    _placeholder={{ color: "gray.400" }}
                    size="lg"
                  />
                  <InputRightElement width="4.5rem">
                    <Button
                      type="submit"
                      colorScheme="purple"
                      isLoading={isSubmitting}
                      isDisabled={isSuccess}
                      size="sm"
                      h="115%"
                      px={4}
                      borderRadius="0 4px 4px 0"
                      _hover={{
                        transform: "translateY(-1px)",
                        boxShadow: "md",
                        transition: "all 0.2s",
                      }}
                    >
                      {isSuccess ? (
                        <Icon as={FiCheck} color="white" />
                      ) : (
                        "Subscribe"
                      )}
                    </Button>
                  </InputRightElement>
                </InputGroup>
                <Text fontSize="xs" color="gray.500" textAlign="center">
                  By subscribing, you agree to receive marketing emails from Luxe Perfumes.
                </Text>
              </VStack>
            </form>
          </VStack>
        </Grid>

        <Divider my={8} borderColor={borderColor} />

        {/* Bottom Section */}
        <Flex
          direction={["column", "row"]}
          justify="space-between"
          align="center"
          gap={4}
        >
          <Text fontSize="sm">
          Copyright ©️ 2025 | Powered by NAFEES ALI TRADERS (SMC-PRIVATE) LIMITED
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
